// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prevention-box-info-tag-area {\n  position: absolute;\n  right: 0;\n  margin: 0;\n  top: 0;\n}\n.prevention-box-info-image {\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
